export default "/images/down.png?fa1055d0aeeb299136f15b61f5abef5c";